module.exports = __webpack_public_path__ + "img/Hayal45.2f6487c3.png";